module.exports = __webpack_public_path__ + "static/media/MHeiHK-Bold.bf021f81.svg";